const CheckQuantityLetters = {
  setCustomizationByLetters: function (formSerialize) {
    const inputCustomization = document.querySelector(`[data-letters]`);

    if (!inputCustomization) return formSerialize;

    const quantityLetters = inputCustomization.value.length;
    const filteredForm = formSerialize.filter((input) => {
      return input.name != inputCustomization.name;
    });

    filteredForm.push({
      name: `customizations[][LETRAS PARA GRAVAÇÃO (${quantityLetters})]`,
      value: inputCustomization.value.toUpperCase()
    });

    return filteredForm;
  },
}

export default CheckQuantityLetters;
